/**
 * Скрипты хедера: mobile-меню, desktop-subnav, favorite toggle.
 */

const HEADER_INNER_SEL = '#header_inner';
const MENU_ROOT_SEL = '#header_menu [data-root]';

function closeAllSubnavMenu() {
    document.querySelector(HEADER_INNER_SEL)?.classList.remove('subnav_active');
    document.querySelectorAll(MENU_ROOT_SEL).forEach(el => el.classList.remove('opened_desktop'));
}

function init() {
    const headerInner = document.querySelector(HEADER_INNER_SEL);

    // Favorite icon toggle
    document.addEventListener('click', e => {
        const fav = e.target.closest('.header_link--favorite');
        if (fav) fav.classList.toggle('active');
    });

    // Desktop submenu: mouseenter на [data-root]
    document.addEventListener('mouseenter', e => {
        const root = e.target.closest?.(MENU_ROOT_SEL);
        if (!root) return;
        closeAllSubnavMenu();
        root.classList.add('opened_desktop');
        if (root.classList.contains('subnav')) {
            headerInner?.classList.add('subnav_active');
        }
    }, true); // capture — event не bubble-ится

    // mouseleave на hedaer_inner / header_block_links — закрыть
    headerInner?.addEventListener('mouseleave', closeAllSubnavMenu);
    document.getElementById('header_block_links')?.addEventListener('mouseleave', closeAllSubnavMenu);

    // Mobile-меню toggle
    document.addEventListener('click', e => {
        if (e.target.closest('#header_menu_handler, #header_menu_closer')) {
            headerInner?.classList.toggle('menu_mobile_opened');
            document.getElementById('site_body')?.classList.toggle('body_fixed');
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
